import { apiCall } from '@/lib/api-client';

export interface HeartbeatPayload {
  state: 'active' | 'idle' | 'on_call' | 'documenting' | 'paused' | 'disconnected';
  screeningId?: string;
  pageUrl?: string;
  keystrokes30s: number;
  mouseClicks30s: number;
  tabFocused: boolean;
  metadata?: Record<string, unknown>;
}

export const heartbeatApi = {
  log: (payload: HeartbeatPayload) =>
    apiCall<void>('/agents/me/heartbeat', {
      method: 'POST',
      body: payload,
    }),
};
